<template>
  <div id="sve" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>

    <div class="layout-content container-fluid mt-5">
      <div class="row p-2 mx-auto">
        <header-v2 :title="'Sistema de vigilancia epidemiológico'" />
        <div class="row w-100 mt-4">
          <div class="col-md-3">
            <Select
              label="Categoría"
              name="categoria"
              :options="items"
              :value="selected"
              v-model="selected"
              @onSelect="onSelect"
              @onRemove="onRemove"
            />
          </div>
        </div>
        <div class="row w-100 mt-5">
          <div class="col-md-12">
            <Tables v-if="selected?.id === 'ges'" :category="category" :type="type" />
            <Diagnostics v-else-if="selected?.id === 'diagnostics-register'" />
            <MatrizIper v-else-if="selected?.id === 'matrix-iper'" />
            <SaludCondition v-else-if="selected?.id === 'salud-condition'" />
            <SaludEvent v-else-if="selected?.id === 'salud-event'" />
            <div v-else class="d-flex flex-column">
              <h5 class="text-center text-black" style="font-size: 18px; font-weight: 700;">Aún no has seleccionado una categoría</h5>
              <div class="d-flex justify-content-center">
                <img
                  class="centerImg1"
                  src="@/assets/modules/health-tracker/img/pill.svg"
                  width="30%"
                  alt="logo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import useInputs from "@/components/general/Inputs";
const { Select } = useInputs();
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import Tables from "./tableSve&Risk.vue";
import Diagnostics from "./formDiagnostics.vue";
import MatrizIper from './matrizIper/MatrizIper.vue'
import SaludCondition from "./saludCondition/SaludCondition.vue";
import SaludEvent from "./saludEvent/SaludEvent.vue";
export default {
  components: {
    HeaderV2: () => import("@/components/common/header/HeaderV2.vue"),
    MainBarMenuV2,
    Select,
    HeadingUser,
    Tables,
    Diagnostics,
    MatrizIper,
    SaludCondition,
    SaludEvent,
  },
  data() {
    return {
      selected: null,
      items: [
        {
          id: "ges",
          name: "GES",
        },
        {
          id: "diagnostics-register",
          name: "Registro de diagnósticos",
        },
        {
          id: "matrix-iper",
          name: "Matriz IPER",
        },
        {
          id: "salud-condition",
          name: "Condición de salud",
        },
        {
          id: "salud-event",
          name: "Eventos de salud",
        },
      ],
      category: this.$route.params.category,
      type: this.$route.params.type,
    };
  },
  computed: {
    ...mapState("modDiagnostics", ["newDiagnosticFromOtherComponent"]),
  },
  methods: {
    onSelect() {
      const me = this;
      if (me.selected) {
        me.$router.push({
          name: "sve",
          params: {
            category: me.selected?.id,
            type: me.selected?.id === "GES" ? "operative" : "null",
          },
        });
      }
    },
    onRemove() {
      const me = this;
      me.$router.push({
        name: "sve",
        params: { category: "null", type: "null" },
      });
    },
    loadCategory() {
      const me = this;
      if (me.category) {
        const item = me.items.find((x) => x.id === me.category);
        me.selected = item ? item : null;
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    const me = this;
    me.category = to.params.category;
    me.type = to.params.type;
    me.loadCategory();
    next();
  },
  mounted() {
    const me = this;
    me.loadCategory();
  },
};
</script>

<style lang="scss" scoped>
#sve {
  .input-vp2,
  button {
    //padding: 10px 10px;
    font-size: 15px; //height: 40px;
    // border-radius: 10px;
  }
  /*button{
    padding: 0 10px;
  }*/
  .vs__dropdown-toggle {
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
    input {
      margin-top: 0px;
    }
  }
  .layout-content {
    .select-category {
      border: none !important;
      position: static;
      width: 98% !important;
      height: 28px;
      left: calc(50% - 412px / 2);
      top: calc(50% - 28px / 2);
      background: #ffffff;
      /* body regular */
      font-family: Ubuntu;
      font-style: normal;
      font-weight: normal;
      font-size: 16px !important;
      line-height: 28px;
      /* content/03 */
      color: #78909c;
      /* Inside auto layout */
      align-self: stretch;
      flex-grow: 1; //margin: 8px;
      border: 0;
      &:focus,
      &:active {
        outline: 0;
        border: 0;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        box-shadow: none !important;
      }
    }
    .select-category:valid + .label-helper {
      color: #78909c;
      opacity: 1;
    }
    .select-category:focus + .label-helper,
    .select-category:active + .label-helper {
      color: #5d5fef;
      opacity: 1;
    }
    .baseline_box {
      width: 383px !important; //margin-top: 60px;
    }
    #baseline_box1:focus-within {
      border-color: #5d5fef;
    }
  }
}

/*.header-top{
  background-color: #F8FCFF;
  width: 100%;
  position: fixed;
  border-width: 0 0 4px 0;
  border-style: solid;
  border-image: linear-gradient(to left, #00A4AC, #00A4AC, #13CCD6) 1;
  z-index: 9;
}*/
</style>
